import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackStartQuickOrderListUploadParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackStartQuickOrderListUpload";

const useTrackStartQuickOrderListUpload = (
    parameters: TrackStartQuickOrderListUploadParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.startQuickOrderListUpload, parameters, options);
};

export default useTrackStartQuickOrderListUpload;
